import React, {Dispatch, SetStateAction, useEffect, useState} from "react"
import {Button, Modal, TransitionablePortal} from "semantic-ui-react"
import { useSwipeable } from "react-swipeable"
import {HowitworksGedcom} from "./howitworks-gedcom"
import {HowitworksIndividuals} from "./howitworks-individuals"
import {HowitworksFamilies} from "./howitworks-families"
import {MouseNavigation} from "./howitworks-mouse-nav"
import {FormattedMessage, useIntl} from "react-intl"


type HowItWorksProps = {
    open: boolean
    onClose: () => void
    setContactModalOpen: Dispatch<SetStateAction<boolean>>
}

export function HowItWorks({ open, onClose, setContactModalOpen }: HowItWorksProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setIsClicked] = useState(false)
    const [currentIndex, setCurrentIndex] = useState(0)
    const intl = useIntl()
    const cards = [
        {
            key: 0,
            component: <HowitworksGedcom setContactModalOpen={setContactModalOpen} onClose={onClose}/>,
            message: <FormattedMessage id="howitworks.gedcom.header" values={{
                gedcom: "GEDCOM"
            }}/>
        },
        {
            key: 1,
            component: <HowitworksIndividuals/>,
            message: <FormattedMessage id="howitworks.individuals.header" values={{
                individuals: (intl.formatMessage({id: "creator.tabs.individuals"})).toLowerCase()
            }}/>
        },
        {
            key: 2,
            component: <HowitworksFamilies/>,
            message: <FormattedMessage id="howitworks.families.header" values={{
                families: (intl.formatMessage({id: "creator.tabs.families"})).toLowerCase()
            }}/>
        }
    ]

    /**
     * Reset slide index to 0 whenever the modal opens.
     */
    useEffect(() => { if (open) setCurrentIndex(0) }, [open])

    const nextSlide = () => {
        if (currentIndex < cards.length - 1) setCurrentIndex(currentIndex + 1)
    }

    const prevSlide = () => {
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1)
    }

    // Handle click feedback
    const handleMouseDown = () => setIsClicked(true)
    const handleMouseUp = () => setIsClicked(false)

    const swipeHandlers = useSwipeable({
        onSwipedLeft: nextSlide,    // swipe left to go to the next slide
        onSwipedRight: prevSlide,   // swipe right to go back
        preventScrollOnSwipe: true, // prevents scrolling while swiping
        trackMouse: true            // allows swipe on desktop too
    })

    return (
        <MouseNavigation onNext={nextSlide} onBack={prevSlide}>
        <TransitionablePortal open={open} transition={{ animation: "fade", duration: 500 }}>
        <Modal closeIcon open={open} onClose={onClose} size="fullscreen" dimmer="inverted">
            <div className="howitworks" {...swipeHandlers}>
                {/* CARDS */}
                {cards[currentIndex].component}
                {/* BUTTONS */}
                <div className="nav-buttons">
                    <Button
                        onClick={prevSlide}
                        color={currentIndex === cards.length - 1 ? "yellow" : "linkedin"}
                        style={{ backgroundColor: currentIndex === cards.length - 1 ? "var(--creator-indi-yellow-active)" : "dodgerblue" }}
                        onMouseDown={handleMouseDown}
                        onMouseUp={handleMouseUp}
                        className={`nav-button left ${currentIndex === 0 ? "carousel-disabled" : ""}`}>
                        <FormattedMessage id="howitworks.button.back"/>:&nbsp;
                        {(currentIndex > 0) && <>{cards[currentIndex - 1].message}</>}
                    </Button>
                    <Button
                        onClick={nextSlide}
                        style={{ backgroundColor: currentIndex === 0 ? "var(--creator-indi-yellow-active)" : "var(--creator-fam-teal-active)" }}
                        onMouseDown={handleMouseDown}
                        onMouseUp={handleMouseUp}
                        className={`nav-button right ${currentIndex === cards.length - 1 ? "carousel-disabled" : ""}`}>
                        <FormattedMessage id="howitworks.button.next"/>:&nbsp;
                        {(currentIndex < cards.length - 1) && <>{cards[currentIndex + 1].message}</>}
                    </Button>
                </div>
                {/* DOTS */}
                <div className={`howitworks-dots ${currentIndex === cards.length - 1 ? "end" : currentIndex === 0 ? "start" : "middle"}`}>
                    {cards.map((_, index) =>
                        <span key={index} className={`dot ${currentIndex === index ? "active" : ""}`} onClick={() => setCurrentIndex(index)}/>
                    )}
                </div>
                {/* FOOTER */}
                <>
                    <p className="patience" style={{ visibility: currentIndex === 0 ? "visible" : "hidden" }}>
                        🌱&nbsp;<FormattedMessage id="howitworks.gedcom.patience"/>
                    </p>
                </>

            </div>
        </Modal>
        </TransitionablePortal>
        </MouseNavigation>
    )
}